import { groq } from 'next-sanity';
import { z } from 'zod';

import { eventCardProjection, SanityEventCard } from './eventCard';
import { eventIsPublicFilter, eventRefIsPublicFilter } from './eventVisibility';
import { link, SanityLink } from './link';

export const SanityHomepageEvents = z.object({
  sectionIndex: z.number().optional().nullable(),
  _type: z.literal('homepageEvents'),
  _key: z.string().optional(),
  headline: z.string(),
  link: SanityLink.optional().nullable(),
  events: z.array(SanityEventCard),
});
export type SanityHomepageEvents = z.infer<typeof SanityHomepageEvents>;

export const homepageEvents = groq`{
  _type,
  headline,
  link[0] ${link},
  'events': select(
    count(events) > 0 => events[${eventRefIsPublicFilter}]-> ${eventCardProjection},
    *[_type == 'event' && defined(slug.current) && ${eventIsPublicFilter} && coalesce(endDate, startDate) >= now()] | order(startDate asc) [0...3] ${eventCardProjection}
  )
}`;
